import dayjs from '@/localPlugins/dayjs';

export const getLocalDateFormat = (format = 'L') => {
  return dayjs().locale(navigator.language).localeData().longDateFormat(format).replace(/MMMM/g, 'MMM');
};

/** Disables calendar dates after today. For use with date-picker `disabled-date`. */
export const disableFutureDate = (time) => time.getTime() > dayjs().endOf('day');

/** Clamps a datetime value to the current moment if it is in the future. */
export const capToNow = (date) => {
  if (!date) return null;
  const selected = dayjs(date);
  const now = dayjs();
  return selected.isAfter(now) ? now.toDate() : date;
};